/**
 * CrtTooltip.jsx — CRT/terminal-themed tooltip primitive.
 *
 * Issue #38 — usage:
 *   <CrtTooltip text="Explanation text here">
 *     <SomeTriggerElement />
 *   </CrtTooltip>
 *
 * The tooltip floats above the trigger child when it is hovered or
 * receives keyboard focus. Styled with a scanline overlay, monospace
 * phosphor-green palette, and a tiny neon glow.
 */

import { createSignal, Show } from 'solid-js';
import './CrtTooltip.css';

export default function CrtTooltip(props) {
  const [visible, setVisible] = createSignal(false);
  const [pos, setPos] = createSignal({ x: 0, y: 0, keyboard: false });

  function moveToMouse(e) {
    setPos({ x: e.clientX, y: e.clientY, keyboard: false });
  }
  function focusAt(el) {
    const r = el.getBoundingClientRect();
    setPos({ x: r.left + r.width / 2, y: r.bottom, keyboard: true });
  }

  return (
    <span
      class="v2-crt-tooltip-wrap"
      onMouseEnter={(e) => { moveToMouse(e); setVisible(true); }}
      onMouseMove={moveToMouse}
      onMouseLeave={() => setVisible(false)}
      onFocusIn={(e) => { focusAt(e.target); setVisible(true); }}
      onFocusOut={() => setVisible(false)}
    >
      {props.children}
      <Show when={visible()}>
        <div
          class="v2-crt-tooltip"
          classList={{ 'is-keyboard': pos().keyboard }}
          role="tooltip"
          style={{ left: `${pos().x}px`, top: `${pos().y}px` }}
        >
          {/* scanline texture overlay */}
          <div class="v2-crt-tooltip__scanlines" aria-hidden="true" />
          <div class="v2-crt-tooltip__content">{props.text}</div>
        </div>
      </Show>
    </span>
  );
}
